import React from 'react';

import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import Heading from '@tds/core-heading';
import Notification from '@tds/core-notification';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

import Table from './components/table';

const Addons = ({
  addonsList,
  contentfulError,
  viewType,
  addons,
  setAddons,
  total,
  setTotal
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: { addonHeading }
  } = localizedStrings;

  return (
    <>
      {contentfulError && (
        <Notification variant="error" copy="en">
          Error fetching addons data from contentful
        </Notification>
      )}

      {!contentfulError && addonsList.length > 0 && (
        <Box between={3}>
          <Heading level="h4">{addonHeading}</Heading>
          <Table
            viewType={viewType}
            addons={addons}
            setAddons={setAddons}
            list={addonsList}
            total={total}
            setTotal={setTotal}
          />
        </Box>
      )}
    </>
  );
};

Addons.propTypes = {
  addonsList: PropTypes.objectOf(PropTypes.any).isRequired,
  contentfulError: PropTypes.objectOf(PropTypes.any).isRequired,
  viewType: PropTypes.string.isRequired,
  addons: PropTypes.arrayOf(PropTypes.object).isRequired,
  setAddons: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired
};

export default Addons;
